---
en:
  admin:
    time_series_trackers:
      by_source:
        ago: "{time} ago"
        columns:
          latest_reading: Latest known reading
          plants: Plants
          source: Source
          status: Status
        load_error: Could not load source health.
        never: Never
        no_plants: No active plants configured for this source.
        no_sources: No sources found.
        plant_columns:
          latest_reading: Latest reading
          plant: Plant
          signal: Signal
          status: Status
        refresh: Refresh
        search_placeholder: Search for a power plant
        show_empty: Show sources with no plants
        signal:
          all: All signals
          heartbeat: Sensor heartbeat
          volume: Volume
        status:
          delayed: Delayed
          down: Down
          no_data: No data
          up: Up
        subtitle: Whether each live data source is reporting or has gone dark.
        title: Data source health
      tabs:
        by_series: By series
        by_source: By source
